export const AccessRestrictionModeFormField = {
  accessRestrictionMode: 'accessRestrictionMode',
  employerBlacklist: 'employerBlacklist',
  employeeBlacklist: 'employeeBlacklist',
  employerWhitelist: 'employerWhitelist',
} as const;
